import React from "react"

import arrowRightImage from "../images/fontawesome/arrow-right-regular.svg"

const ArrowRight = () => (
  <img
    src={arrowRightImage}
    alt="Pil åt höger"
    height="16px"
    width="16px"
    className="icon"
  />
)

export default ArrowRight
